




































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericPMSTableMenu from "@/components/generic-pms-table/GenericPMSTableMenu.vue";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableTable from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import DateField from "@/components/misc/DateField.vue";
import GuestReviewForm from "../components/GuestReviewForm.vue";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { Notification } from "../store/modules/notifications";
import * as _ from "lodash";
import NoData from "@/components/misc/NoData.vue";
import { GuestReview, GuestReviewStatus } from "@/shared/models/guestReview";
import { Action, Getter } from "vuex-class";
import { GuestReviewStatusEnum } from "@/shared/models/enums.type";

@Component({
  components: {
    GenericPMSTableMenu,
    SortableHeadersTable,
    GuestReviewForm,
    DateField,
    NoData
  },
  directives: {
    SortableTable,
  },
})
export default class GuestReviewTable extends Vue {

  @Action("codebooks/refreshGuestReviewStatuses")
  refreshGuestReviewStatuses?: () => Promise<void>;
  @Getter("codebooks/guestReviewStatuses")
  guestReviewStatuses?: GuestReviewStatus[];
  
  settingsOpen = false;

  async created(){
    const promises = [];

    if (
      (this.guestReviewStatuses?.length ?? 0) === 0 &&
      this.refreshGuestReviewStatuses
    ) {
      promises.push(this.refreshGuestReviewStatuses());
    }

    await Promise.all(promises);
  }

  headers: SortableTableHeader[] = [
    {
      text: "GuestReview.SubmittedDate",
      value: "reviewSubmitDate",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: ["reviewSubmitDate"],
    },
    {
      text: "GuestReview.ApprovalDate",
      value: "reviewApprovalDate",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "GuestReview.GuestName",
      value: "guestName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "GuestReview.Property",
      value: "propertyName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "GuestReview.UnitType",
      value: "accomodationUnitTypeName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "GuestReview.GeneralScore",
      value: "generalScore",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "GuestReview.Status",
      value: "statusId",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },

    {
      text: "Actions",
      value: "actions",
      sortable: false,
      active: true,
      default: true,
      class: "resize-header",
      exportHeaders: [],
    },
  ];

  filters = {
    reviewSubmitDate: "",
    reviewApprovalDate: "",
    guestName: "",
    propertyName: "",
    accomodationUnitTypeName: "",
    statusId: null as number | null,
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: [""],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  loading = true;
  list: ListModel<GuestReview> = {
    count: 0,
    result: [],
  };

  debouncedLoad = _.debounce(this.load, 500);

  async load(): Promise<ListModel<GuestReview>> {
    this.loading = true;

    return (
      this.axios
        .get<ListModel<GuestReview>>("/GuestReviews", {
          params: this.queryParams,
        })
        .then((res) => {
          this.list = res.data;
          return this.list;
        })
        .finally(() => (this.loading = false))
    );
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
    };
  }

  guestReviewFormOpen = false;
  guestReviewId: number | null = null;

  rowDoubleClick(e: MouseEvent, { item }: { item: GuestReview }) {
    this.openItemDetails(item);
  }
  async openItemDetails(item: GuestReview) {
    this.guestReviewId = item.id
    this.guestReviewFormOpen = true;
  }

  addItem() {
    this.guestReviewId = null;
    this.guestReviewFormOpen = true;
  }

  deleteItem(item: GuestReview) {
    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("DeleteConfirmation"),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteItemConfirm(item);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deleteItemConfirm({ id }: { id: number }) {
    Vue.axios
      .delete(`/GuestReviews/${id}`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("GuestReview.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.load();
      });
  }

  getStatusText(statusId: number) {
    switch(statusId){
      case GuestReviewStatusEnum.Submitted:
        return "t.GuestReviewStatus.Submitted"
      case GuestReviewStatusEnum.Approved:
        return "t.GuestReviewStatus.Approved"
      case GuestReviewStatusEnum.Removed:
        return "t.GuestReviewStatus.Removed"
    }
  }
}
